import { Link } from "react-router-dom";
import { Star, UserCheck, Building2, ShieldCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCountUp } from "@/lib/hooks";

const STATS = [
  [Star, 10000, "+", "Happy Customers"],
  [UserCheck, 500, "+", "Verified Professionals"],
  [Building2, 50, "+", "Cities Served"],
  [ShieldCheck, 180, " Days", "Warranty (up to)"],
];

const Counter = ({ icon: I, target, suffix, label, i }) => {
  const [ref, val] = useCountUp(target);
  return (
    <div ref={ref} className="card-soft lift p-5" data-testid={`trust-stat-${i}`}>
      <I className="h-5 w-5 text-primary" />
      <p className="font-display text-2xl sm:text-3xl font-extrabold mt-3 text-primary">{val.toLocaleString("en-IN")}{suffix}</p>
      <p className="text-sm font-medium">{label}</p>
    </div>
  );
};

export const TrustStats = () => (
  <section className="container-x section-y" data-testid="trust-stats-section">
    <div className="grid lg:grid-cols-[1.25fr_1fr] gap-8 items-center">
      <div className="relative">
        <img src="/img/technician-customer-v2.webp" alt="Onkaal technician explaining an AC repair to a customer at home" loading="lazy" width="1264" height="848"
          className="w-full aspect-[3/2] object-cover rounded-[2rem] shadow-2xl shadow-primary/10" data-testid="trust-stats-image" />
        <div className="absolute -bottom-5 right-6 card-soft px-5 py-3 flex items-center gap-2 bg-card/95 backdrop-blur-xl">
          <span className="flex text-amber-400">{[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}</span>
          <span className="text-sm font-semibold">Service with a smile</span>
        </div>
      </div>
      <div>
        <span className="eyebrow">Trusted across India</span>
        <h2 className="h2 mt-2">Real experts. Real homes. Real results.</h2>
        <p className="mt-3 text-muted-foreground">Our professionals explain the problem, quote upfront and fix it right — so you always know what you're paying for.</p>
        <div className="grid grid-cols-2 gap-3 mt-8">
          {STATS.map(([I, t, s, l], i) => <Counter key={l} icon={I} target={t} suffix={s} label={l} i={i} />)}
        </div>
        <Button asChild className="mt-8 rounded-full h-12 px-7" data-testid="trust-stats-book-button">
          <Link to="/book">Book a Professional <ArrowRight className="h-4 w-4 ml-1" /></Link>
        </Button>
      </div>
    </div>
  </section>
);
